<img
  [src]="path + imageUrl"
  [alt]="'PROGRESS_BAR.COMPLETE_ICON' | translate"
  data-testid="node-img" />
